var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field is-horizontal" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "field-body" }, [
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control" }, [
          _c("div", { staticClass: "select is-fullwidth" }, [
            _c(
              "select",
              {
                attrs: { id: "gender", name: "gender" },
                domProps: { value: _vm.value },
                on: {
                  input: function ($event) {
                    return _vm.$emit("input", $event.target.value)
                  },
                },
              },
              [
                _c("option", { attrs: { value: "male" } }, [_vm._v("Male")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "female" } }, [
                  _vm._v("Female"),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label", attrs: { for: "gender" } }, [
        _vm._v("Gender"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }